
  import { Options, Vue } from 'vue-class-component';
  import { ref } from 'vue';

  import NavBar from '@/components/navigation/NavBar.vue';
  import CustomerNavDrawer from '@/views/userportal/navigation/CustomerNavDrawer.vue';

  @Options({
      components: {        
          NavBar,
          CustomerNavDrawer,
      },
  })
  export default class CustomerNavigation extends Vue {
    
    
    setCurrentPage(selectedPage: any) : void
    {
      this.$emit('currentPage', selectedPage)
    }
  }

  // private const pageOptions: Array<string>  = ['home-view', 'module-management', 'request-tutor-view', 'tutorial-session-admin'];
  
